export const branchList = (state, rootState) => {
	return state.branchList;
}

export const objBranchEdit = (state, rootState) => {
	return state.objBranchEdit;
}

export const branchLogo = (state, rootState) => {
	return state.branchLogo;
}
